import MTNLogo from "../../../../assets/logo/JPEG/MTN_2022_Logo_Black_RGB.jpg";
import image from "../../../../assets/logo/JPEG/image.jpeg";
 
function AuthLayout({ children }) {
  return (
    <div className="flex min-h-screen w-full bg-white">
      {/* Left Side (form) */}
      <div className="relative flex flex-col items-center justify-center w-full md:w-1/2 px-8 md:px-16 py-12">
        {/* Logo */}
        <div className="absolute top-6 left-6 md:left-20">
          <img
            src={MTNLogo}
            alt="MTN Logo"
            className="object-contain w-28 md:w-auto h-12 md:h-20"
          />
        </div>
 
        {/* Content container (centers form and limits width) */}
        <div className="w-full max-w-sm">{children}</div>
      </div>
 
      {/* Right Side (image) */}
      <div className="hidden md:block relative w-1/2 h-screen overflow-hidden">
        <img
          src={image}
          alt="Recruitment visual"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* optional overlay */}
        {/* <div className="absolute inset-0 bg-black opacity-20" /> */}
      </div>
    </div>
  );
}
 
export default AuthLayout;